// Datenschutz.js – Seite /datenschutz (Rechtstext) mit Link „Cookie-Einstellungen“ (öffnet den Banner über consent.js).
import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./custom.css";
import { oeffneCookieEinstellungen } from "../../consent";
import usePageMeta from "../../usePageMeta";
import betrieb from "../../data/betrieb";

// Muss zu dem passen, was die Seite tatsächlich lädt (src/consent.js, public/index.html, Kontaktformular).
// Bei neuen Diensten oder einem Wechsel des Hosters hier anpassen und das Datum unten ändern.
function Datenschutz() {
  usePageMeta({
    path: "/datenschutz",
    title: "Datenschutzerklärung | Forst & Flur",
    description:
      "Datenschutzerklärung von Forst & Flur: welche Daten beim Besuch der Website und über das Kontaktformular verarbeitet werden und welche Rechte Sie haben.",
  });

  return (
    <div>
      <div className="ff-page-hero ff-page-hero--compact">
        <div className="ff-page-hero__content">
          <h1 className="ff-page-hero__title">Datenschutz</h1>
        </div>
      </div>
      <div className="custom-dark-green text-white">
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col xs={12} lg={9} className="ff-legal">
        <p>
          Das Unternehmen {betrieb.name} ({betrieb.rechtsname}, Inhaber {betrieb.inhaber})
          nimmt den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln
          personenbezogene Daten vertraulich und entsprechend der
          Datenschutz-Grundverordnung (DSGVO), dem
          Telekommunikation-Digitale-Dienste-Datenschutz-Gesetz (TDDDG) und
          dieser Datenschutzerklärung.
        </p>

        <h2 className="ff-article-h3">1. Verantwortliche Stelle</h2>
        {/* Gleicher Block wie im Impressum (src/data/betrieb.js) */}
        <p>
          {betrieb.name}
          <br />
          {betrieb.rechtsname}
          <br />
          Inhaber: {betrieb.inhaber}
          <br />
          {betrieb.strasse}
          <br />
          {betrieb.plz} {betrieb.ort}
          <br />
          Telefon: {betrieb.telefon}
          <br />
          E-Mail: {betrieb.email}
        </p>

        <h2 className="ff-article-h3">2. Aufruf der Website und Server-Protokolle</h2>
        <p>
          Die Website wird bei der Hetzner Online GmbH, Industriestraße 25,
          91710 Gunzenhausen, in Deutschland betrieben. Mit Hetzner besteht ein
          Vertrag über die Auftragsverarbeitung (Art. 28 DSGVO).
        </p>
        <p>
          Beim Aufruf der Seite überträgt Ihr Browser technisch notwendige
          Daten: IP-Adresse, Datum und Uhrzeit, aufgerufene Adresse, die zuvor
          besuchte Seite (Referrer), Browser und Betriebssystem. Diese Daten
          brauchen wir, um die Seite auszuliefern und Störungen oder Angriffe
          zu erkennen. Sie werden in Protokolldateien des Servers gespeichert,
          die fortlaufend automatisch überschrieben werden, und nur bei
          Störungen oder Angriffen ausgewertet. Rechtsgrundlage ist unser
          berechtigtes Interesse an einem sicheren und funktionierenden Betrieb
          der Website (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
        <p>
          Die Verbindung ist per HTTPS verschlüsselt. Schriftarten und alle
          übrigen Bestandteile der Seite werden von unserem eigenen Server
          geladen. Ohne Ihre Einwilligung baut die Seite keine Verbindung zu
          Servern anderer Anbieter auf.
        </p>

        <h2 className="ff-article-h3">3. Kontaktformular, E-Mail und Telefon</h2>
        <p>
          Wenn Sie uns per Kontaktformular, E-Mail oder Telefon erreichen,
          verarbeiten wir Ihre Angaben (z. B. Name, E-Mail-Adresse,
          Telefonnummer, Nachricht), um Ihre Anfrage zu beantworten und ein
          Angebot zu erstellen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
          (Anbahnung eines Vertrags), bei allgemeinen Anfragen unser
          berechtigtes Interesse an der Beantwortung (Art. 6 Abs. 1 lit. f
          DSGVO).
        </p>
        <p>
          Das Kontaktformular übermittelt Ihre Eingaben über den Dienst
          EmailJS (EmailJS Pte. Ltd., Singapur) als E-Mail an uns. EmailJS
          betreibt seine Server bei Amazon Web Services in den USA und
          speichert den Versandverlauf bis zu 30 Tage. Mit EmailJS besteht ein
          Vertrag über die Auftragsverarbeitung. Die Übermittlung in
          Drittländer ist durch die EU-Standardvertragsklauseln abgesichert
          (Art. 46 Abs. 2 lit. c DSGVO). Wenn Sie das nicht möchten, erreichen
          Sie uns ebenso per E-Mail oder Telefon.
        </p>
        <p>
          Wir löschen Ihre Anfrage, wenn sie erledigt ist und keine
          gesetzlichen Aufbewahrungspflichten (z. B. für Angebote und
          Rechnungen nach Handels- und Steuerrecht, bis zu 10 Jahre)
          entgegenstehen.
        </p>

        <h2 className="ff-article-h3">4. Cookie-Einstellungen</h2>
        <p>
          Beim ersten Besuch fragen wir, ob Sie der Besucherstatistik
          (PostHog) und der Erfolgsmessung unserer Werbung (Google Ads)
          zustimmen. Erst nach Ihrer Zustimmung werden diese Dienste geladen.
          Ihre Auswahl speichern wir im lokalen Speicher Ihres Browsers
          (Eintrag „cookie_consent_v2“), damit wir nicht bei jedem Seitenaufruf
          erneut fragen. Dieses Speichern ist technisch notwendig (§ 25 Abs. 2
          Nr. 2 TDDDG) und dient dem Nachweis Ihrer Einwilligung (Art. 6 Abs. 1
          lit. c in Verbindung mit Art. 7 Abs. 1 DSGVO).
        </p>
        <p>
          Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft
          widerrufen oder ändern, über den Link „Cookie-Einstellungen“ unten
          auf jeder Seite oder hier:
        </p>
        <p>
          <button type="button" className="btn-ff-outline" onClick={oeffneCookieEinstellungen}>
            Cookie-Einstellungen öffnen
          </button>
        </p>
        <p>
          Bei einem Widerruf löschen wir die von PostHog und Google Ads in
          Ihrem Browser abgelegten Daten und laden die Seite ohne diese
          Dienste neu.
        </p>

        <h2 className="ff-article-h3">5. Besucherstatistik mit PostHog</h2>
        <p>
          Nur mit Ihrer Einwilligung nutzen wir PostHog, einen Dienst der
          PostHog Inc. (San Francisco, USA), um zu verstehen, welche Seiten
          besucht werden, und die Website zu verbessern. Wir nutzen die
          europäische PostHog Cloud (eu.i.posthog.com), die Daten werden auf
          Servern in Frankfurt am Main gespeichert.
        </p>
        <p>
          Erfasst werden aufgerufene Seiten, die zuvor besuchte Seite,
          Verweildauer, Browser, Betriebssystem, Bildschirmgröße, die aus der
          IP-Adresse abgeleitete ungefähre Region und das Absenden des
          Kontaktformulars (ohne dessen Inhalt). Zur Wiedererkennung legt
          PostHog eine zufällige Kennung im lokalen Speicher Ihres Browsers ab
          (Einträge, die mit „ph_“ beginnen). Die IP-Adresse wird von PostHog
          nicht gespeichert. Klicks, Eingaben und Bildschirmaufzeichnungen
          werden nicht erfasst.
        </p>
        <p>
          Rechtsgrundlage ist Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO,
          § 25 Abs. 1 TDDDG). Mit PostHog besteht ein Vertrag über die
          Auftragsverarbeitung. Für einen möglichen Zugriff aus den USA gelten
          die EU-Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO). Die
          Kennung in Ihrem Browser bleibt bis zu Ihrem Widerruf oder bis Sie den
          Browser-Speicher löschen. Die Statistikdaten bei PostHog bewahren wir
          nur so lange auf, wie wir sie für die Auswertung brauchen. Weitere
          Informationen: https://posthog.com/privacy
        </p>

        <h2 className="ff-article-h3">6. Google Ads Conversion-Tracking</h2>
        <p>
          Nur mit Ihrer Einwilligung nutzen wir das Conversion-Tracking von
          Google Ads. Anbieter ist die Google Ireland Limited, Gordon House,
          Barrow Street, Dublin 4, Irland. Damit messen wir, ob ein Besuch über
          eine unserer Google-Anzeigen zu einer Anfrage über das
          Kontaktformular führt. Google setzt dafür Cookies (z. B. „_gcl_au“,
          Laufzeit bis 90 Tage) und verarbeitet Angaben zu Ihrem Gerät, Ihre
          IP-Adresse und die Information, dass Sie auf eine Anzeige geklickt
          haben. Wir erhalten nur zusammengefasste Zahlen, keine Daten, die Sie
          persönlich erkennen lassen. Personalisierte Werbung (Remarketing)
          nutzen wir nicht.
        </p>
        <p>
          Rechtsgrundlage ist Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO,
          § 25 Abs. 1 TDDDG). Google verarbeitet die Daten teilweise in eigener
          Verantwortung und kann sie in die USA übermitteln. Die Google LLC ist
          unter dem EU-US Data Privacy Framework zertifiziert, für die USA
          besteht damit ein Angemessenheitsbeschluss der EU-Kommission (Art. 45
          DSGVO). Sind Sie bei Google angemeldet, kann Google die Daten Ihrem
          Konto zuordnen. Weitere Informationen:
          https://policies.google.com/privacy
        </p>

        <h2 className="ff-article-h3">7. Links zu sozialen Netzwerken</h2>
        <p>
          Auf unser Instagram-Profil verweisen wir mit einem einfachen Link.
          Beim Besuch unserer Seite werden keine Daten an Instagram
          übertragen. Erst wenn Sie den Link anklicken, gelangen Sie zu
          Instagram (Meta Platforms Ireland Limited), dort gilt deren
          Datenschutzerklärung.
        </p>

        <h2 className="ff-article-h3">8. Ihre Rechte</h2>
        <p>
          Sie haben das Recht auf Auskunft über Ihre bei uns gespeicherten
          Daten (Art. 15 DSGVO), auf Berichtigung (Art. 16), Löschung (Art.
          17), Einschränkung der Verarbeitung (Art. 18) und
          Datenübertragbarkeit (Art. 20). Eine erteilte Einwilligung können Sie
          jederzeit mit Wirkung für die Zukunft widerrufen (Art. 7 Abs. 3
          DSGVO).
        </p>
        <p>
          <strong>Widerspruchsrecht:</strong> Verarbeiten wir Daten auf
          Grundlage unseres berechtigten Interesses (Art. 6 Abs. 1 lit. f
          DSGVO), können Sie aus Gründen, die sich aus Ihrer besonderen
          Situation ergeben, jederzeit widersprechen (Art. 21 DSGVO).
        </p>
        <p>
          Sie können sich außerdem bei einer Datenschutz-Aufsichtsbehörde
          beschweren (Art. 77 DSGVO), zum Beispiel bei der für uns zuständigen:
          Unabhängiges Landeszentrum für Datenschutz Schleswig-Holstein,
          Holstenstraße 98, 24103 Kiel.
        </p>
        <p>
          Für alle Fragen zum Datenschutz und zur Ausübung Ihrer Rechte
          erreichen Sie uns unter den Kontaktdaten in Abschnitt 1.
        </p>

        <p className="mt-4">Stand: Oktober 2026</p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Datenschutz;
